var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInjectionUnit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 383,
    height: 310,
    viewBox: "0 0 383 310",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 280,
    width: 92,
    height: 30,
    rx: 15,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.508 290.624V299H177.828V290.624H179.508ZM184.852 292.256C185.644 292.256 186.284 292.508 186.772 293.012C187.26 293.508 187.504 294.204 187.504 295.1V299H185.824V295.328C185.824 294.8 185.692 294.396 185.428 294.116C185.164 293.828 184.804 293.684 184.348 293.684C183.884 293.684 183.516 293.828 183.244 294.116C182.98 294.396 182.848 294.8 182.848 295.328V299H181.168V292.352H182.848V293.18C183.072 292.892 183.356 292.668 183.7 292.508C184.052 292.34 184.436 292.256 184.852 292.256ZM189.953 291.56C189.649 291.56 189.397 291.468 189.197 291.284C189.005 291.092 188.909 290.856 188.909 290.576C188.909 290.296 189.005 290.064 189.197 289.88C189.397 289.688 189.649 289.592 189.953 289.592C190.249 289.592 190.493 289.688 190.685 289.88C190.877 290.064 190.973 290.296 190.973 290.576C190.973 290.856 190.877 291.092 190.685 291.284C190.493 291.468 190.249 291.56 189.953 291.56ZM190.781 300.092C190.781 300.828 190.597 301.356 190.229 301.676C189.869 302.004 189.349 302.168 188.669 302.168H187.925V300.74H188.405C188.661 300.74 188.841 300.688 188.945 300.584C189.049 300.488 189.101 300.328 189.101 300.104V292.352H190.781V300.092ZM198.621 295.532C198.621 295.772 198.605 295.988 198.573 296.18H193.713C193.753 296.66 193.921 297.036 194.217 297.308C194.513 297.58 194.877 297.716 195.309 297.716C195.933 297.716 196.377 297.448 196.641 296.912H198.453C198.261 297.552 197.893 298.08 197.349 298.496C196.805 298.904 196.137 299.108 195.345 299.108C194.705 299.108 194.129 298.968 193.617 298.688C193.113 298.4 192.717 297.996 192.429 297.476C192.149 296.956 192.009 296.356 192.009 295.676C192.009 294.988 192.149 294.384 192.429 293.864C192.709 293.344 193.101 292.944 193.605 292.664C194.109 292.384 194.689 292.244 195.345 292.244C195.977 292.244 196.541 292.38 197.037 292.652C197.541 292.924 197.929 293.312 198.201 293.816C198.481 294.312 198.621 294.884 198.621 295.532ZM196.881 295.052C196.873 294.62 196.717 294.276 196.413 294.02C196.109 293.756 195.737 293.624 195.297 293.624C194.881 293.624 194.529 293.752 194.241 294.008C193.961 294.256 193.789 294.604 193.725 295.052H196.881ZM199.416 295.676C199.416 294.988 199.556 294.388 199.836 293.876C200.116 293.356 200.504 292.956 201 292.676C201.496 292.388 202.064 292.244 202.704 292.244C203.528 292.244 204.208 292.452 204.744 292.868C205.288 293.276 205.652 293.852 205.836 294.596H204.024C203.928 294.308 203.764 294.084 203.532 293.924C203.308 293.756 203.028 293.672 202.692 293.672C202.212 293.672 201.832 293.848 201.552 294.2C201.272 294.544 201.132 295.036 201.132 295.676C201.132 296.308 201.272 296.8 201.552 297.152C201.832 297.496 202.212 297.668 202.692 297.668C203.372 297.668 203.816 297.364 204.024 296.756H205.836C205.652 297.476 205.288 298.048 204.744 298.472C204.2 298.896 203.52 299.108 202.704 299.108C202.064 299.108 201.496 298.968 201 298.688C200.504 298.4 200.116 298 199.836 297.488C199.556 296.968 199.416 296.364 199.416 295.676ZM209.022 293.732V296.948C209.022 297.172 209.074 297.336 209.178 297.44C209.29 297.536 209.474 297.584 209.73 297.584H210.51V299H209.454C208.038 299 207.33 298.312 207.33 296.936V293.732H206.538V292.352H207.33V290.708H209.022V292.352H210.51V293.732H209.022ZM212.571 291.56C212.275 291.56 212.027 291.468 211.827 291.284C211.635 291.092 211.539 290.856 211.539 290.576C211.539 290.296 211.635 290.064 211.827 289.88C212.027 289.688 212.275 289.592 212.571 289.592C212.867 289.592 213.111 289.688 213.303 289.88C213.503 290.064 213.603 290.296 213.603 290.576C213.603 290.856 213.503 291.092 213.303 291.284C213.111 291.468 212.867 291.56 212.571 291.56ZM213.399 292.352V299H211.719V292.352H213.399ZM218.01 299.108C217.37 299.108 216.794 298.968 216.282 298.688C215.77 298.4 215.366 297.996 215.07 297.476C214.782 296.956 214.638 296.356 214.638 295.676C214.638 294.996 214.786 294.396 215.082 293.876C215.386 293.356 215.798 292.956 216.318 292.676C216.838 292.388 217.418 292.244 218.058 292.244C218.698 292.244 219.278 292.388 219.798 292.676C220.318 292.956 220.726 293.356 221.022 293.876C221.326 294.396 221.478 294.996 221.478 295.676C221.478 296.356 221.322 296.956 221.01 297.476C220.706 297.996 220.29 298.4 219.762 298.688C219.242 298.968 218.658 299.108 218.01 299.108ZM218.01 297.644C218.314 297.644 218.598 297.572 218.862 297.428C219.134 297.276 219.35 297.052 219.51 296.756C219.67 296.46 219.75 296.1 219.75 295.676C219.75 295.044 219.582 294.56 219.246 294.224C218.918 293.88 218.514 293.708 218.034 293.708C217.554 293.708 217.15 293.88 216.822 294.224C216.502 294.56 216.342 295.044 216.342 295.676C216.342 296.308 216.498 296.796 216.81 297.14C217.13 297.476 217.53 297.644 218.01 297.644ZM226.395 292.256C227.187 292.256 227.827 292.508 228.315 293.012C228.803 293.508 229.047 294.204 229.047 295.1V299H227.367V295.328C227.367 294.8 227.235 294.396 226.971 294.116C226.707 293.828 226.347 293.684 225.891 293.684C225.427 293.684 225.059 293.828 224.787 294.116C224.523 294.396 224.391 294.8 224.391 295.328V299H222.711V292.352H224.391V293.18C224.615 292.892 224.899 292.668 225.243 292.508C225.595 292.34 225.979 292.256 226.395 292.256ZM235.16 290.624V295.808C235.16 296.376 235.308 296.812 235.604 297.116C235.9 297.412 236.316 297.56 236.852 297.56C237.396 297.56 237.816 297.412 238.112 297.116C238.408 296.812 238.556 296.376 238.556 295.808V290.624H240.248V295.796C240.248 296.508 240.092 297.112 239.78 297.608C239.476 298.096 239.064 298.464 238.544 298.712C238.032 298.96 237.46 299.084 236.828 299.084C236.204 299.084 235.636 298.96 235.124 298.712C234.62 298.464 234.22 298.096 233.924 297.608C233.628 297.112 233.48 296.508 233.48 295.796V290.624H235.16ZM245.555 292.256C246.347 292.256 246.987 292.508 247.475 293.012C247.963 293.508 248.207 294.204 248.207 295.1V299H246.527V295.328C246.527 294.8 246.395 294.396 246.131 294.116C245.867 293.828 245.507 293.684 245.051 293.684C244.587 293.684 244.219 293.828 243.947 294.116C243.683 294.396 243.551 294.8 243.551 295.328V299H241.871V292.352H243.551V293.18C243.775 292.892 244.059 292.668 244.403 292.508C244.755 292.34 245.139 292.256 245.555 292.256ZM250.657 291.56C250.361 291.56 250.113 291.468 249.913 291.284C249.721 291.092 249.625 290.856 249.625 290.576C249.625 290.296 249.721 290.064 249.913 289.88C250.113 289.688 250.361 289.592 250.657 289.592C250.953 289.592 251.197 289.688 251.389 289.88C251.589 290.064 251.689 290.296 251.689 290.576C251.689 290.856 251.589 291.092 251.389 291.284C251.197 291.468 250.953 291.56 250.657 291.56ZM251.485 292.352V299H249.805V292.352H251.485ZM255.1 293.732V296.948C255.1 297.172 255.152 297.336 255.256 297.44C255.368 297.536 255.552 297.584 255.808 297.584H256.588V299H255.532C254.116 299 253.408 298.312 253.408 296.936V293.732H252.616V292.352H253.408V290.708H255.1V292.352H256.588V293.732H255.1Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M229.547 275.996L232.621 281.319H226.474L229.547 275.996Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M171.719 161.688H202.635C207.244 161.688 211.004 165.434 211.004 170.056V175.366C211.004 179.975 207.257 183.735 202.635 183.735H171.719V161.701V161.688Z",
    fill: "#6A5DFF",
    stroke: "url(#paint0_linear_3239_23828)",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M147.192 12.5293C147.192 12.5293 60.8066 29.8872 152.475 168.494L147.192 12.5293Z",
    fill: "#6A5DFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.192 12.5293C147.192 12.5293 60.8066 29.8872 152.475 168.494",
    stroke: "url(#paint1_linear_3239_23828)",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.394 38.1602C147.394 38.1602 106.452 81.5549 152.488 155.528L147.394 38.1602Z",
    fill: "#6A5DFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M147.394 38.1602C147.394 38.1602 106.452 81.5549 152.488 155.528",
    stroke: "url(#paint2_linear_3239_23828)",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83814 242.869H146.774V212.277H0V216.644H4.48774L4.83814 242.869Z",
    fill: "#6A5DFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2996 215.742H2.14282V219.691H68.2996V215.742Z",
    fill: "#6A5DFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3912 212.277V222.021H71.4396V216.186V212.277H69.3912Z",
    fill: "#6A5DFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M146.774 215.742V219.704H71.4396V215.742",
    fill: "#6A5DFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M177.433 75.0325H145.642V3.98378L147.987 2.90565C155.884 -0.719563 164.913 -0.962142 172.999 2.23182L177.433 3.98378V75.0325Z",
    fill: "#6A5DFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M185.088 75.0312H136.976V103.386H185.088V75.0312Z",
    fill: "#6A5DFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M172.595 131.757H149.469L138.755 103.389H183.484L172.595 131.757Z",
    fill: "#6A5DFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M149.645 131.756H172.77L172.959 214.017H149.254L149.645 131.756Z",
    fill: "#6A5DFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M182.352 132.267L190.209 122.294V65.3957C190.209 65.3957 208.443 56.9863 216.852 65.3957C217.688 76.3387 216.852 115.596 216.852 115.596L182.352 132.267Z",
    fill: "#6A5DFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M147.394 24.9141H175.695C177.177 24.9141 178.39 26.127 178.39 27.6094H144.698C144.698 26.127 145.911 24.9141 147.394 24.9141Z",
    fill: "#6A5DFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M147.394 38.1602H175.695C177.177 38.1602 178.39 39.3731 178.39 40.8555H144.698C144.698 39.3731 145.911 38.1602 147.394 38.1602Z",
    fill: "#6A5DFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M139.672 102.041H183.74C185.223 102.041 186.436 103.254 186.436 104.736H136.976C136.976 103.254 138.189 102.041 139.672 102.041Z",
    fill: "#6A5DFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M215.505 81.2598H191.489C190.745 81.2598 190.142 81.8631 190.142 82.6074C190.142 83.3517 190.745 83.9551 191.489 83.9551H215.505C216.249 83.9551 216.852 83.3517 216.852 82.6074C216.852 81.8631 216.249 81.2598 215.505 81.2598Z",
    fill: "#6A5DFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M194.845 122.082V86.1799C194.845 85.0613 195.141 84.1719 195.519 84.1719C195.896 84.1719 196.193 85.0748 196.193 86.1799V122.082C196.193 123.2 195.896 124.09 195.519 124.09C195.141 124.09 194.845 123.187 194.845 122.082Z",
    fill: "#6A5DFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M200.68 119.611V86.041C200.68 85.0033 200.977 84.1543 201.354 84.1543C201.732 84.1543 202.028 85.0033 202.028 86.041V119.611C202.028 120.649 201.732 121.498 201.354 121.498C200.977 121.498 200.68 120.649 200.68 119.611Z",
    fill: "#6A5DFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M206.529 117.661V85.9508C206.529 84.967 206.826 84.1719 207.203 84.1719C207.58 84.1719 207.877 84.967 207.877 85.9508V117.661C207.877 118.645 207.58 119.44 207.203 119.44C206.826 119.44 206.529 118.645 206.529 117.661Z",
    fill: "#6A5DFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M212.5 115.393V85.8119C212.5 84.8955 212.796 84.1543 213.173 84.1543C213.551 84.1543 213.847 84.8955 213.847 85.8119V115.393C213.847 116.31 213.551 117.051 213.173 117.051C212.796 117.051 212.5 116.31 212.5 115.393Z",
    fill: "#6A5DFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M149.887 130.408H170.816C172.299 130.408 173.511 131.621 173.511 133.104H147.192C147.192 131.621 148.405 130.408 149.887 130.408Z",
    fill: "#6A5DFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M217.486 100.611H209.09V112.673H217.486V100.611Z",
    fill: "#6A5DFF",
    stroke: "url(#paint3_linear_3239_23828)",
    strokeWidth: 0.62,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M308.345 212.277V250.969H374.731C374.731 250.969 392.83 212.277 374.731 212.277H308.345Z",
    fill: "#6A5DFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M374.744 192.615H328.075V212.278H374.744V192.615Z",
    fill: "#6A5DFF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M146.774 198.074H299.99C304.599 198.074 308.359 201.821 308.359 206.443V246.63C308.359 251.239 304.612 254.999 299.99 254.999H146.774V198.088V198.074Z",
    fill: "#6A5DFF",
    stroke: "url(#paint4_linear_3239_23828)",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M172.959 137.643L216.852 115.596V154.732H172.824L172.959 137.643Z",
    fill: "#6A5DFF",
    stroke: "url(#paint5_linear_3239_23828)",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M217.688 197.453C217.688 197.453 214.871 199.246 206.516 183.721L217.688 197.453Z",
    fill: "#6A5DFF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M217.688 197.453C217.688 197.453 214.871 199.246 206.516 183.721",
    stroke: "url(#paint6_linear_3239_23828)",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M230.881 198.073C230.881 198.073 219.345 194.664 210.99 179.139L230.881 198.073Z",
    fill: "#6A5DFF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M230.881 198.073C230.881 198.073 219.345 194.664 210.99 179.139",
    stroke: "url(#paint7_linear_3239_23828)",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3239_23828",
    x1: 171.045,
    y1: 172.711,
    x2: 211.664,
    y2: 172.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A45825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8DFD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3239_23828",
    x1: 108.298,
    y1: 90.0738,
    x2: 154.173,
    y2: 90.0738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A97C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#603913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3239_23828",
    x1: 128.594,
    y1: 96.6891,
    x2: 154.2,
    y2: 96.6891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A97C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#603913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3239_23828",
    x1: 208.672,
    y1: 106.649,
    x2: 217.904,
    y2: 106.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3239_23828",
    x1: 146.1,
    y1: 226.537,
    x2: 309.019,
    y2: 226.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A45825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8DFD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3239_23828",
    x1: 172.137,
    y1: 134.948,
    x2: 217.526,
    y2: 134.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A45825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8DFD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3239_23828",
    x1: 205.923,
    y1: 190.796,
    x2: 218.052,
    y2: 190.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A45825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8DFD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3239_23828",
    x1: 210.397,
    y1: 188.774,
    x2: 231.07,
    y2: 188.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A45825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8DFD4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInjectionUnit);
export default __webpack_public_path__ + "static/media/InjectionUnit.9f3662460aee7ac7d26a4bc731e9f49b.svg";
export { ForwardRef as ReactComponent };